import type { IModalLogoutTranslations } from '@/Contexts/GLModalLogout/types/translations';

const ptBR: IModalLogoutTranslations = {
  title: 'Sessão expirada',
  description:
    'Sua sessão expirou por questões de segurança. Clique em OK para fazer login novamente.',
  buttonText: 'Ok',
};

export { ptBR };
